export default "__VITE_ASSET__b744400b__"